import { render } from "./SoftSnackbar.vue?vue&type=template&id=3d17ace2"
import script from "./SoftSnackbar.vue?vue&type=script&lang=js"
export * from "./SoftSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__